import { handleAzureAdB2cCallback } from 'lib/auth/AuthHandlers';
import { User } from 'oidc-client';
import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import reportWebVitals from './reportWebVitals';

// ReactDOM.render(
// 	<React.StrictMode>
// 		<App />
// 	</React.StrictMode>,
// 	document.getElementById('root')
// );

// reportWebVitals(console.log);
async function startApp(user?: User, error?: Error | null, status?: string) {
	try {
		ReactDOM.render(
			user ? (
				<React.StrictMode>
					<App authenticatedUser={user} />
				</React.StrictMode>
			) : (
				<></>
			),
			document.getElementById('root')
		);
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error(error);
	}
}
async function handleError(error: Error | null, status?: string) {
	// eslint-disable-next-line no-console
	if (error) console.error(error);

	await startApp(undefined, error, status);
}

handleAzureAdB2cCallback(startApp, handleError);
